import { MouseEvent } from 'react'
import { Link, LinkProps } from 'react-router-dom'

import { isPreviewMode } from 'utils/StyleUtils'

import { RouterLink } from '../RouterLink'

const isPreview = isPreviewMode()

interface Props extends LinkProps {
  textLink?: boolean
}

const PreviewModeLink = ({
  children,
  textLink = true,
  ...restProps
}: Props) => {
  const _onClick = (event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault()

    return null
  }

  const LinkComponent = textLink ? RouterLink : Link

  if (isPreview) {
    return (
      <LinkComponent {...restProps} onClick={_onClick}>
        {children}
      </LinkComponent>
    )
  }

  return <LinkComponent {...restProps}>{children}</LinkComponent>
}

export default PreviewModeLink
